import { GetIssueGroupRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const ISSUE_GROUPS_API_PATHS = {
    ISSUE_GROUPS: '/issuesgroups',
}

class IssuesGroupApi extends ApiBase {
    async findByCompanyId(companyId: string) {
        if (!companyId) {
            return []
        }
        const fetchedIssueGroups = await this._getRequest<GetIssueGroupRequest>(ISSUE_GROUPS_API_PATHS.ISSUE_GROUPS, {
            queryParameters: { companyId },
        })

        return fetchedIssueGroups
    }
}

export default IssuesGroupApi
